import React, { useState } from 'react';
import { Poppins, Settings } from 'src/common';
import CommonMenu from 'src/components/CommonMenu';
import { AssessmentSelect } from 'src/components/select/AssessmentSelect';
import { DashboardQuery } from 'src/graphql/_generated';
import styled from 'styled-components';
import { PdfExportModalInsights } from 'src/components/modals';

const Div = styled.div``;

interface HeadProps {
  isEmpty: boolean;
  selectedAssessment: string;
  setSelectedAssessmentStored: (assessmentId: string) => void;
  data?: DashboardQuery;
}

export const Head: React.FC<HeadProps> = ({
  isEmpty,
  selectedAssessment,
  setSelectedAssessmentStored,
  data,
}) => {
  const [anchorEl, setAnchorEl] = useState<React.MouseEvent['currentTarget'] | null>(null);
  const [isExportModalOpen, setIsExportModalOpen] = useState(false);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handlePdfClick = (e: React.MouseEvent<HTMLLIElement>) => {
    e.stopPropagation();
    handleClose();
    setIsExportModalOpen(true);
  };

  if (!data) return null;

  return (
    <>
      <CommonMenu onPdfClick={handlePdfClick} anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose} />
      {isExportModalOpen && (
        <PdfExportModalInsights
          onClose={() => setIsExportModalOpen(false)}
          assessmentId={selectedAssessment}
        />
      )}
      <Div className="panel">
        <Poppins px={32} weight={600}>
          Insights
        </Poppins>
        {!isEmpty && (
          <div className="panel">
            <AssessmentSelect value={selectedAssessment} onChange={(opt) => setSelectedAssessmentStored(opt.value)} />
            <Settings
              active={!!anchorEl}
              onClick={(e) => {
                e.stopPropagation();
                setAnchorEl(e.currentTarget);
              }}
              variant="button"
              dataCy="common-menu"
            />
          </div>
        )}
      </Div>
    </>
  );
};
